import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Form, Input } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/operacaoLimpezaTag/actions';

import Chip from '../components/Chip';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [taghistoricotag, setTag] = React.useState(false);
  const [idcompartimento, setIdCompartimento] = React.useState(false);

  const { client, id } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaoLimpezaTag
  );

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        observacaohistoricotag: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .trim()
          .max(250, t('s.geral.validacao.tamanhomaximo').replace('%s', 250)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        idhistoricotag: 0,
        idcliente: client,
        tipohistoricotag: 1,
        datahorahistoricotag: null,
        idveiculo: initials.idveiculo,
        idempresaveiculo: initials.idempresaveiculo,
        taghistoricotag,
        idcompartimento,
        idusuario: id,
        observacaohistoricotag: param.observacaohistoricotag.trim(),
      };

      if (taghistoricotag) {
        if (create) {
          await dispatch(storeData(objSend, params));
        } else {
          await dispatch(updateData(objSend, params));
          await setTag(false);
        }
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            disabled
            name="idveiculo"
            label={t('s.operacao.limpezatag.idveiculo')}
          />

          <Input
            disabled
            name="placaveiculo"
            label={t('s.operacao.limpezatag.placaveiculo')}
          />

          <Chip
            title={t('s.operacao.limpezatag.taghistoricotag')}
            options={initials.transponders}
            onDelete={(value) => setTag(value)}
            onCompartiment={(value) => setIdCompartimento(value)}
          />

          <Input
            multiline
            name="observacaohistoricotag"
            label={t('s.operacao.limpezatag.observacaohistoricotag')}
            rows={4}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
